import { useQuery } from "@tanstack/react-query";
import type { TimeClockEligibility } from "@truckbuddy/contract";
import { apiRequest } from "./api";
import { useAppSession } from "./shell";

export function useTimeClockEligibility(enabled = true) {
  const { user, previewRole } = useAppSession();
  return useQuery({ queryKey: ["time-clock-eligibility", user.userId, previewRole], enabled,
    queryFn: ({ signal }) => apiRequest<TimeClockEligibility>("/time-clock/eligibility", { signal }),
    refetchInterval: 30_000, refetchOnWindowFocus: true });
}
